module.exports = __webpack_public_path__ + "img/et.2ebb0d3d.svg";